import {charcoal} from '../sass/base/_exports.sass';

export const TransferIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox="0 0 31 30"
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0834 15L25.3334 10L19.0834 5V8.74875H2.83337V11.2487H19.0834V15ZM27.8334 18.75H11.5834V15L5.33337 20L11.5834 25V21.25H27.8334V18.75Z"
        fill={color}
      />
    </svg>
  );
};
